import {
  Schema as AccountSchema,
  PartnersCapitalCategory,
} from 'further-types/lp/account';
import { z } from 'zod';
import { isMongoId } from '../../helpers';

export const CreateTransactionType = z.object({
  accountId: z.string().refine(isMongoId()),
  name: z.string().min(1, 'Please enter transaction type name.'),
});

export const UpdateTransactionType = z.object({
  transactionTypeId: z.string().refine(isMongoId()),
  name: z.string().min(1, 'Please enter transaction type name.'),
});

export const DeleteTransactionType = z.object({
  transactionTypeId: z.string().refine(isMongoId()),
});

export const ImportTransactionTypes = z.object({
  file: z.string().min(1, 'Please select a file.'),
  filename: z.string().optional().nullable(),
});

export const ValidateUploadedTransactionType = z
  .object({
    id: z
      .string()
      .optional()
      .refine(isMongoId({ optional: true }), 'Invalid transaction id.'),
    accountCode: z.string().min(1, 'Account code is required.'),
    accountSection: z.nativeEnum(AccountSchema.AccountSection, {
      errorMap: () => ({
        message:
          'Invalid account section. Must be one of: assets, payables, partnersCapital, income, expenses',
      }),
    }),
    accountName: z.string().min(1, 'Account name is required.'),
    name: z.string().min(1, 'Transaction name is required.'),
    payableReceivableCategory: z
      .nativeEnum(AccountSchema.PayableReceivableCategory)
      .nullable()
      .optional(),
    incomeExpenseCategory: z.string().nullable().optional(),
    balanceSheetSection: z
      .nativeEnum(AccountSchema.BalanceSheetSection)
      .optional(),
    partnersCapitalCategory: z
      .nativeEnum(PartnersCapitalCategory)
      .nullable()
      .optional(),
  })
  .refine(
    (data) => {
      if (
        data.accountSection === AccountSchema.AccountSection.Assets ||
        data.accountSection === AccountSchema.AccountSection.Payables
      ) {
        return !!data.balanceSheetSection;
      }
      return true;
    },
    {
      message:
        'Balance sheet section is required for Assets and Payables accounts',
      path: ['balanceSheetSection'],
    },
  );
